module.exports = __webpack_public_path__ + "img/back invisible zipper length.ab93e349.png";